import message from './message';
import common from './common';
import field from './fields';
import constant from './constants';
import document from './documents';
import section from './sections';
import validation from './validation';
import error from './error';

export default {
  message,
  common,
  field: {
    ...field,
    ...document,
  },
  constant,
  document,
  section,
  validation,
  error,
};
